import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import styles from "./style.module.scss";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import { FaRegFloppyDisk } from "react-icons/fa6";
import { ReactTyped } from "react-typed";
import { Link } from "react-router-dom";

const Introduction = () => {
  const handleResumeClick = () => {
    window.open(
      "https://drive.google.com/file/d/1TE5J854AL2tRpnJ0hrLaDFF5JqEaQDLV/view",
      "_blank"
    );
  };

  return (
    <>
      <Row className={"mt-5 pt-3  " + styles.row}>
        <Col xs md="12" lg="5">
          <div className={styles.image_square}>
            <img
              src="/assets/images/sqare.svg"
              alt="square"
              className={styles.square}
            />
            <img
              src="/assets/images/my-image.png"
              alt="square"
              className={styles.onsquare}
            />
          </div>
        </Col>
        <Col xs md="12" lg="6">
          <div className={styles.introduce}>
            <div className={styles.introduce_sec}>
              <ReactTyped
                startWhenVisible
                strings={["<h1>Mahmoud Abdulraheem Odeh</h1>"]}
                typeSpeed={80}
              />
              <h5>Full Stack Developer</h5>
              <p>Hey there, I'm Mahmoud , With over 3 years of experience.</p>
            </div>
            <div className={styles.introduce_social}>
              <Link
                to={"https://www.linkedin.com/in/mahmoud-odeh-a9399b20a/"}
                target="_blank"
                className={styles.introduce_social_item}
              >
                <AiFillLinkedin />
              </Link>
              <Link
                to={"https://github.com/Mah9988"}
                target="_blank"
                className={styles.introduce_social_item}
              >
                <AiFillGithub />
              </Link>
            </div>
            <div className={styles.introduce_resume}>
              <p>My Resume</p>
              <Button onClick={() => handleResumeClick()}>
                <span>Download</span> <FaRegFloppyDisk />
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Introduction;
